import React, { useState, useEffect, useMemo } from 'react';
import { Empty, Checkbox, Button, Row, Input } from 'antd';
import { CloseCircleFilled, SearchOutlined } from '@ant-design/icons';
import './index.less';

export default function SelectorPanel({
  selectValTreeNode = [],
  deletItem,
  beforeDelet,
  disabled,
  placeholder,
  searchPlaceholder,
  subtitle,
}) {
  const [seletedItem, setseletedItem] = useState([]); // 选中的元素
  const [filterVal, setFilterVal] = useState(''); // 筛选框内容

  useEffect(() => {
    if (!selectValTreeNode.length) {
      setseletedItem([]);
    }
    const arr = selectValTreeNode.map((item) => item.parentValue);
    setseletedItem((seletedItem) => (seletedItem.length ? seletedItem.filter((ele) => arr.includes(ele)) : []));
  }, [selectValTreeNode, filterVal, disabled]);

  const subTreeNode = useMemo(() => {
    return selectValTreeNode.filter(
      (item) => item.parentName.toLocaleLowerCase().indexOf(filterVal.toLocaleLowerCase()) >= 0
    );
  }, [selectValTreeNode, filterVal]);

  const indeterminate = useMemo(() => {
    // 控制半选状态
    return !!seletedItem.length && seletedItem.length < subTreeNode.length;
  }, [subTreeNode, seletedItem]);

  const checkAll = useMemo(() => {
    // 控制全选状态
    return subTreeNode.length === seletedItem.length;
  }, [subTreeNode, seletedItem]);

  function handleChange(list) {
    setseletedItem(list);
  }

  function selectAll(e) {
    setseletedItem(e.target.checked ? subTreeNode.map((e) => e.parentValue) : []);
  }

  function handleDelet(seletedItem) {
    if (!seletedItem.length) return;
    if (beforeDelet) {
      beforeDelet().then(() => {
        deletItem(seletedItem);
        setseletedItem([]);
      });
    } else {
      deletItem(seletedItem);
      setseletedItem([]);
    }
  }

  function handleFilterChange(e) {
    const targetVal = e.target.value;
    setFilterVal(targetVal);
  }

  const renderLabel = (label, str) => {
    const reg = new RegExp(str, 'gi');
    return label.replace(reg, (word) => {
      return `<em class='caseader-search-highlight' style="display: inline-block; font-style: normal;">${word}</em>`;
    });
  };

  return (
    <div className="result-panal">
      {selectValTreeNode.length > 0 ? (
        <>
          <div className="result-panal-header">
            <div className="result-search">
              <Input
                className="result-search-input"
                allowClear
                onChange={handleFilterChange}
                placeholder={searchPlaceholder}
                suffix={<SearchOutlined style={{ color: 'rgba(0,0,0,.45)' }} />}
              />
            </div>
            <Button onClick={() => handleDelet(seletedItem)} type="primary" ghost disabled={disabled}>
              删除
            </Button>
          </div>
          <div className="title">
            <div>
              {subtitle}（{selectValTreeNode.length}个）
            </div>
          </div>
          {subTreeNode.length > 0 ? (
            <Checkbox onChange={selectAll} indeterminate={indeterminate} checked={checkAll} disabled={disabled}>
              全选
            </Checkbox>
          ) : (
            <Empty className="result-empty" image={Empty.PRESENTED_IMAGE_SIMPLE} />
          )}
          <div className="list">
            <Checkbox.Group onChange={handleChange} value={seletedItem}>
              {subTreeNode.map((item) => {
                return (
                  <Row key={item.parentValue} className="list-item">
                    <Checkbox disabled={disabled} value={item.parentValue}>
                      <span
                        className="list-item-text ellipsis-1-line"
                        dangerouslySetInnerHTML={{ __html: renderLabel(item.parentName, filterVal) }}
                      />
                    </Checkbox>
                    {!disabled && (
                      <CloseCircleFilled
                        onClick={() => handleDelet([item.parentValue])}
                        className="list-item-delet-incon"
                      />
                    )}
                  </Row>
                );
              })}
            </Checkbox.Group>
          </div>
        </>
      ) : (
        <Empty description={placeholder} image={null} />
      )}
    </div>
  );
}
